import { MainLayout } from "../layout/MainLayout";
import MyRecentTasks from "./MyRecentTasks";
import { IntroMessage } from "../blocks/IntroMessage";
import { Beginnings } from "../blocks/Beginnings";

interface AppItemProps {
    name: string;
}

export default function Dashboard(props: AppItemProps) {
    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-lg-8">
                        <IntroMessage />
                    </div>
                    <div className="col-xs-12 col-lg-4">
                        <Beginnings />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <MyRecentTasks />
                    </div>
                </div>
            </div>
        </MainLayout>);
}